import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/000a7dc9257076fa91b1218ef0cfa389.js')["default"];

var scope_1 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/040985cbfabff7c8d74a416271481773.js')["default"];

var scope_2 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0509c48722abb32eaf56db7cde17de2a.js')["default"];

var scope_3 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0787f41fa1cf702e7ffe049bd5580ea3.js')["default"];

var scope_4 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0d61126c135463d8d9cf6b0ad62cc6a4.js')["default"];

var scope_5 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/19409fe2b4e9140e882df1477627f938.js')["default"];

var scope_6 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/268401c32b069c4e7ecb9bdb9eda3342.js')["default"];

var scope_7 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/27b883e53d62bf44233e258b08d0491d.js')["default"];

var scope_8 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2a9e5d80e56746cf9593942d1c77db57.js')["default"];

var scope_9 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/328d9f7e0c1705795b4cfb7e46ca2e2f.js')["default"];

var scope_10 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3d9f57cb9cde4b9e295aba5b6aac2ed9.js')["default"];

var scope_11 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3de7f62798f242a6a06a2c04d571db0a.js')["default"];

var scope_12 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4129f2e29d76b70f412752e85c4ac53a.js')["default"];

var scope_13 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/43f9c227028ceebc49b2007f0db3c7dc.js')["default"];

var scope_14 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4b0f308b25b55e74a51e6d18e3cdfd30.js')["default"];

var scope_15 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/505c26cefb52b08644f7ba813a4d7fec.js')["default"];

var scope_16 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/54d375ff9f72e5dd73abe8ad2cf8ff25.js')["default"];

var scope_17 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/54d66941a29ff71c1a5f803dbd3e6cf0.js')["default"];

var scope_18 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/54e09a560818d422b8699e9bce90632f.js')["default"];

var scope_19 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5c1e51df00849c0e9f9e53b0e12eda0c.js')["default"];

var scope_20 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5c5089c5a152fadb5fa04abe2db2f947.js')["default"];

var scope_21 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/603e32240ac1d6994c144f18e3b47136.js')["default"];

var scope_22 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/69db6fdb0e0612faa5b096aebcbccf54.js')["default"];

var scope_23 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6c2f167fce55e943b867a257ac442ec7.js')["default"];

var scope_24 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6fc4d6bd386f237ece6f0da8e24c3dc5.js')["default"];

var scope_25 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/72b469150b1e252dffb487e98b425373.js')["default"];

var scope_26 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/862cf81747f29a0621db2a91e326cd07.js')["default"];

var scope_27 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/888dec13791e73025e30abb1cf4ae4a9.js')["default"];

var scope_28 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8e93e5c1a836d4471eac862277733930.js')["default"];

var scope_29 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/916983159ccc2a9f3b4e206bdf85d0bf.js')["default"];

var scope_30 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/929cf44e2e806ac252fdb9af1cec1d06.js')["default"];

var scope_31 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/92ef67f7886de56592737f5b6fd6dbbc.js')["default"];

var scope_32 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9b8539333b30d3970ba376d4d943bded.js')["default"];

var scope_33 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9c73b5b0d8ec08889c79dab23c183750.js')["default"];

var scope_34 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a0c78b558d2d34434b6283d9c8399dca.js')["default"];

var scope_35 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a4c44aac84975b4ff913fcbc59bc3c47.js')["default"];

var scope_36 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aa1b93883bb698615a3e335a7ab16f19.js')["default"];

var scope_37 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ad3c8bff30d2c2c99f7454d98034d903.js')["default"];

var scope_38 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b16044dc2037398d27f9c928fa55635b.js')["default"];

var scope_39 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b17638018bcc8caa7cc04d3cd0df0f81.js')["default"];

var scope_40 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b2501912c418873f7d4c89f19d1e7fc1.js')["default"];

var scope_41 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb1bc6f1c4e2bbfa73f72779ba7e7151.js')["default"];

var scope_42 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bcc4313efba5d8445394001663bad788.js')["default"];

var scope_43 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c2d9706a1a7721750a6119e644b05026.js')["default"];

var scope_44 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c875d2fe06ecc00f1ae0125db06b2ca4.js')["default"];

var scope_45 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c885a560af1727982860d4366953e380.js')["default"];

var scope_46 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ceb14af22c7cfd0549b1cd46f412a86a.js')["default"];

var scope_47 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d445937423189da8ce177ca4d06b8256.js')["default"];

var scope_48 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d8d548effca51f50a87787f007edaf27.js')["default"];

var scope_49 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d9b5eff2c46f34b5e418c3d94ceff3c0.js')["default"];

var scope_50 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d9c6b02a340ecd05002e01e3943189d3.js')["default"];

var scope_51 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dacf516a686ee91f37bf00f68dec514c.js')["default"];

var scope_52 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dcd3fda1777f4f6055d51ebeddd41e69.js')["default"];

var scope_53 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/df99e826f1d655920c2fd2334cdb2d84.js')["default"];

var scope_54 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e319b6a8ae1bafdffbd8ab998760ea26.js')["default"];

var scope_55 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e3ed7e6ebd7ada391b1988319a239755.js')["default"];

var scope_56 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js')["default"];

var scope_57 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eb248435bd2915d80f1fb4d6fb87fd27.js')["default"];

var scope_58 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/edf02aa0234c0f2373bedba1258cb767.js')["default"];

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18, scope_19, scope_20, scope_21, scope_22, scope_23, scope_24, scope_25, scope_26, scope_27, scope_28, scope_29, scope_30, scope_31, scope_32, scope_33, scope_34, scope_35, scope_36, scope_37, scope_38, scope_39, scope_40, scope_41, scope_42, scope_43, scope_44, scope_45, scope_46, scope_47, scope_48, scope_49, scope_50, scope_51, scope_52, scope_53, scope_54, scope_55, scope_56, scope_57, scope_58);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}